var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"number"},[_vm._v("404")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('span',[_vm._v("Ooops...")]),_c('br'),_vm._v("page not found")])])}
var staticRenderFns = []

export { render, staticRenderFns }